import React  from 'react';

const CrossIcon = () => {

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="13.814" height="13.814" viewBox="0 0 13.814 13.814">
        <path id="icon-cross" d="M9.24.509c.435.435.7.782.348,1.13L6.371,4.855,9.588,8.071c.435.435.087.7-.348,1.13s-.782.7-1.13.348L4.894,6.333,1.677,9.549C1.243,9.984.9,9.636.547,9.2c-.348-.348-.7-.7-.348-1.13L3.416,4.855.2,1.639C-.235,1.2.113.943.547.509s.7-.7,1.13-.348L4.894,3.377,8.11.161C8.458-.187,8.805.074,9.24.509Z" transform="translate(0 6.921) rotate(-45)" fill="#fff"/>
      </svg>
      
    );
  };
  

  

export default CrossIcon;

